<template>
    <div class="pageShare" style="marginTop: 120px;">
        <!-- 提取码提取文件 -->
        <Row v-if="tiqu">
            <Col :xs="{ span: 18, offset: 3 }" :md="{ span: 12, offset: 6 }" :lg="{ span: 6, offset: 9 }">
                <h2 class="login-header">
                    <img src="/img/login.png" alt/>
                </h2>
                <!-- border:1px solid #eee; -->
                <Form :model="user" ref="user" action="javascript:void(0)" style="padding:10%">
                    <FormItem prop="name">
                        <div>请输入提取码：</div>
                        <Input v-model="user.ma" style="width: 55%;marginRight:10px"></Input>
                        <Button type="success" @click="toti">提取文件</Button>
                    </FormItem>
                </Form>
            </Col>
        </Row>
        <!-- 文件详情 -->
        <div class="fileInfo" style="padding:0 30px;" v-if="fInfo">
            <!-- 顶 -->
            <div class="fTop" style="display:flex;justify-content: space-between; align-items: center;">
                <div class="fName" style="display:flex; align-items: center;">
                    <img
                            src="/statics/console/img/folder.png"
                            class="tu_folder"
                            style="width:20px;marginRight:10px"
                            v-if="media_share.media_type == 1"
                    />
                    <span style="fontWeight:bold;">{{media_share.media_name}}</span>
                </div>
                <div class="fBtn">
                    <Button type="primary" ghost icon="md-download" :loading="downloadMediaStatus" @click="downloadMedia">下载</Button>
                </div>
            </div>
            <!-- 时间 -->
            <div
                    class="fTime"
                    style="borderBottom:1px solid #eee;display:flex;align-items: center;lineHeight:50px"
            >
                <Icon type="ios-time-outline" style="marginRight:10px;fontSize:14px"/>
                <span style="marginRight:10px;">{{media_share.created_at}}</span>
                <span style="color:red">过期时间：{{media_share.expire_hour}}小时后</span>
            </div>
            <!-- 文件导航 -->
            <div style="marginTop:20px;">
                <!--                <span>全部文件</span>-->
                <div id="crumbs" style="display: flex;border-bottom: 1px solid rgba(0,0,0,0.12);">
                    <ul style="padding-bottom: 20px;" class="mbx">
                        <li v-if="parentid > 0" @click="findChind(-1)">
                            <img src="/statics/console/img/back.png" alt class="back"/>
                        </li>
                        <li v-for="(item,index) in bread_crumbs" :key="index" @click="findChind(item.id)">
                            <a>{{item.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 文件列表 -->
            <!-- <div class="fTitle" style="marginTop:5px;lineHeight:40px;backgroundColor:#eee;padding:0 10px">
              <span style="width:60%;display: inline-block;">文件名</span>
              <span style="width:20%;display: inline-block;">大小</span>
              <span style="width:20%;display: inline-block;">修改日期</span>
            </div>
            <div class="fList" style="display: flex;lineHeight:40px;borderBottom:1px solid #eee;padding:0 10px">
              <span style="width:60%;display: flex;align-items: center;">
                <img
                  src="/statics/console/img/folder.png"
                  class="tu_folder"
                  style="width:20px;marginRight:10px"
                />
                <span style="cursor: pointer;">文件名文件名文件名</span>
              </span>
              <span style="width:20%;display: inline-block;">-</span>
              <span style="width:20%;display: inline-block;">202210-8 15:00</span>
            </div>-->
            <div class="fTible" style="marginTop:5px;">
                <Table :columns="columns" :data="media_list" @on-row-dblclick="clickRow" @on-selection-change="selectChange"></Table>
            </div>
        </div>
        <Modal title="图片" v-model="visible" style="text-align:center" :footer-hide="true">
            <img :src="imgUrl" v-if="visible" style="max-width:100%;max-height:100%" footer-hide></img>
        </Modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                downloadMediaStatus: false,
                visible: false,
                imgUrl: '',
                media_share:{
                    expire_hour: 0,
                    created_at: '',
                    media_name: '',
                    media_type: 2,
                },
                tiqu: true,
                fInfo: false,
                user: {
                    ma: ""
                },
                columns: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "文件名",
                        key: "media_name",
                        render: (h, params) => {
                            if (params.row.type == 1) {
                                var arr = [
                                    h("img", {
                                        attrs: {
                                            src: "/statics/console/img/folder.png",
                                            style: "width:20px;height:20px;vertical-align: bottom;"
                                        }
                                    }),
                                    h(
                                        "span",
                                        {
                                            style: {
                                                marginLeft: "5px"
                                            }
                                        },
                                        params.row.media_name
                                    )
                                ];
                            } else {
                                var arr = [
                                    h(
                                        "span",
                                        {
                                            style: {
                                                marginLeft: "5px"
                                            }
                                        },
                                        params.row.media_name
                                    )
                                ];
                            }
                            return h("div", arr);
                        }
                    },
                    // {
                    //     title: "大小",
                    //     key: "big"
                    // },
                    {
                        title: "添加时间",
                        key: "created_at"
                    },
                    {
                        title: "修改时间",
                        key: "updated_at"
                    }
                ],
                media_list: [],
                bread_crumbs: [],
                back_id: 0,
                parentid: 0,
                link: '',
                select_medias: [],
            };
        },
        created() {
            this.parentid = parseInt(
                !this.$route.query.parentid ? 0 : this.$route.query.parentid
            );
            this.link = !this.$route.query.link ? '' : this.$route.query.link;
            // var code = localStorage.getItem("link_" + this.link);
            var code = sessionStorage.getItem("link_" + this.link);
            if (code !== undefined && code !== '' && code !== null) {
                this.tiqu = false;
                this.fInfo = true;
                this.getList();
            } else {
                this.tiqu = true;
                this.fInfo = false;
            }
        },
        methods: {
            selectChange(e) {
                this.select_medias = e;
            },
            downloadMedia() {
                this.downloadMediaStatus = true;
                var code = sessionStorage.getItem("link_" + this.link);
                let mediaIds = [];
                this.select_medias.forEach(item => {
                    mediaIds.push(item.id);
                });
                this.$api.mediaShare.downloadsharemedialink({
                    link: this.link,
                    code: code,
                    media_ids: JSON.stringify(mediaIds),
                }).then(res => {
                    if (res.code == 200) {
                        this.downloadMediaStatus = false;
                        window.open(res.result.download_link);
                    }
                });
            },
            clickRow(e) {
                if (e.type == 1) {
                    this.findChind(e.id);
                }
                if (e.type == 2 && e.file_type === 'pic') {
                    this.imgUrl = this.$publicData.ossUrl + e.path;
                    this.visible = true;
                }
            },
            // 点击文件夹
            findChind(id) {
                if (id == -1) {
                    if (this.back_id > 0) {
                        this.parentid = this.back_id;
                        this.$router.push("/share/index?link=" + this.link + "&parentid=" + this.back_id);
                        this.getList();
                    } else {
                        this.parentid = 0;
                        this.$router.push("/share/index?link=" + this.link);
                        this.getList();
                    }
                } else if (id > 0) {
                    //   进入子集
                    this.parentid = id;
                    this.$router.push("/share/index?link=" + this.link + "&parentid=" + id);
                    this.getList();
                } else {
                    // 进入首页
                    this.parentid = 0;
                    this.$router.push("/share/index?link=" + this.link);
                    this.getList();
                }
            },
            // 点击提取文件
            toti() {
                if (this.user.ma == '') {
                    this.$Message.warning("请输入提取码");
                    return false;
                }

                this.$api.mediaShare.checksharecode({
                    link: this.link,
                    code: this.user.ma,
                }).then(res => {
                    if (res.code == 200) {
                        // localStorage.setItem("link_" + this.link, this.user.ma);
                        sessionStorage.setItem("link_" + this.link, this.user.ma);
                        this.tiqu = false;
                        this.fInfo = true;
                        this.getList();
                    }
                });
            },
            getList() {
                var code = sessionStorage.getItem("link_" + this.link);
                this.$api.mediaShare
                    .sharebreadcrumblist({
                        link: this.link,
                        code: code,
                        parent_id: this.parentid,
                    })
                    .then(res => {
                        if (res.code == 200) {
                            this.back_id = res.result.back_id;
                            this.bread_crumbs = res.result.bread_crumbs;
                        }
                    });
                this.$api.mediaShare.sharemedialist({
                    link: this.link,
                    code: code,
                    parent_id: this.parentid,
                }).then(res => {
                    if (res.code == 200) {
                        this.select_medias = [];
                        this.media_list = res.result.media_list;
                        this.media_share.created_at = res.result.media_share.created_at;
                        this.media_share.expire_hour = res.result.media_share.expire_hour;
                        this.media_share.media_name = res.result.media_share.media_name;
                        this.media_share.media_type = res.result.media_share.media_type;
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .ivu-table-wrapper {
        border: 0
    }

    .mbx li {
        float: left;
        padding-left: 10px;
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mbx li .back {
        width: 13px;
        margin-right: 5px;
        cursor: pointer;
    }

    li a {
        color: #afb3bf;
    }

    .mbx li:last-child a {
        color: #000;
    }

    .mbx li:not(:last-child) a::after {
        display: inline;
        content: ">";
        margin-left: 10px;
    }
</style>